/** 将有效 token 数量简写为 K/M；兼容平台常见的十进制与二进制窗口大小。 */
export const formatTokenCount = (value: number): string => {
  if (!value || value <= 0) return '0';
  if (value >= 1_024 && value % 1_024 === 0) {
    const binaryThousands = value / 1_024;
    const isBinaryWindow = Number.isInteger(binaryThousands)
      && (binaryThousands & (binaryThousands - 1)) === 0;
    if (isBinaryWindow) {
      return binaryThousands >= 1_024
        ? `${binaryThousands / 1_024}M`
        : `${binaryThousands}K`;
    }
  }
  if (value >= 1_000_000) {
    const millions = value / 1_000_000;
    return `${Number.isInteger(millions) ? millions : millions.toFixed(1)}M`;
  }
  if (value >= 1_000) {
    const thousands = value / 1_000;
    return `${Number.isInteger(thousands) ? thousands : thousands.toFixed(1)}K`;
  }
  return String(value);
};
